import React, { useEffect, useState, useRef, useMemo } from 'react'
import Button from '@material-ui/core/Button'
import PipelineRuns from '~components/page/AzurePipelines/PipelineRuns'
import PipelineJobs from '~components/page/AzurePipelines/PipelineJobs'
import PipelineStages from '~components/page/AzurePipelines/PipelineStages'
import Typography from '@material-ui/core/Typography'
import PendingButton from 'shared-ui/components/atoms/PendingButton/PendingButton'
import RunNewBuild from '~components/page/AzurePipelines/RunNewBuild'

/**
 * Props:
 * - org: your Azure DevOps organization (e.g. "myOrg")
 * - project: project name
 * - repoId: repository ID
 * - definitionId: pipeline definition ID
 */
export default function AzurePipelines(props) {
  const { api } = props

  const [jobs, setJobs] = useState([])
  const [timeline, setTimeline] = useState([])

  const [runDetailsLoading, setRunDetailsLoading] = useState(false)

  const [buildId, setBuildId] = useState(null)
  const [env, setEnv] = useState('develop')

  const onRunHistoryClick = async buildId => {
    setBuildId(buildId)
    setRunDetailsLoading(true)
    const { request } = await api.getPipelineBuild(buildId)
    const build = await request
    setTimeline(build.timeline)
    setRunDetailsLoading(false)
  }

  const [open, setOpen] = useState(false)
  const onDrawerClose = () => {
    setOpen(false)
  }

  const [runs, setRuns] = useState([])
  const [historyLoading, setHistoryLoading] = useState(false)

  const fetchHistory = async env => {
    setHistoryLoading(true)
    try {
      const { request } = api.getPipelineRuns({ branch: `refs/heads/${env}` })
      const result = await request

      setRuns(result)
    } catch (e) {
      console.error('Error fetching history', e)
    } finally {
      setHistoryLoading(false)
    }
  }

  useEffect(() => {
    // fetchHistory(env)
  }, [env])

  const handleEnvChange = env => {
    setEnv(env)
    setBuildId(null)
  }

  return (
    <div className={'flex w-full flex-col items-center justify-center'}>
      {/*<div className={'flex w-full flex-row'}>*/}
      {/*  <div className={'flex flex-grow justify-between'}>*/}
      {/*    <Typography variant="h4" color="textSecondary">*/}
      {/*      Azure Pipelines*/}
      {/*    </Typography>*/}
      {/*    <div className={'mb-6 flex gap-x-2'}>*/}
      {/*      <Button variant="contained" onClick={() => setOpen(true)}>*/}
      {/*        Run New*/}
      {/*      </Button>*/}
      {/*      <PendingButton*/}
      {/*        pending={historyLoading}*/}
      {/*        variant="outlined"*/}
      {/*        onClick={() => fetchHistory(env)}*/}
      {/*        disabled={historyLoading}*/}
      {/*        className="mb-4"*/}
      {/*      >*/}
      {/*        {historyLoading ? 'Loading…' : 'Refresh'}*/}
      {/*      </PendingButton>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<div className="mb-2 flex gap-x-6">*/}
      {/*  {['develop', 'staging', 'master'].map(e => (*/}
      {/*    <Button*/}
      {/*      variant={e === env ? 'contained' : 'outlined'}*/}
      {/*      className={'w-1/3'}*/}
      {/*      onClick={env => handleEnvChange(e)}*/}
      {/*    >*/}
      {/*      {e}*/}
      {/*    </Button>*/}
      {/*  ))}*/}
      {/*</div>*/}
      {/*<div className={'mt-8 flex w-full flex-1 flex-row gap-x-2'}>*/}
      {/*  <PipelineRuns*/}
      {/*    className={'w-[25%]'}*/}
      {/*    api={api}*/}
      {/*    env={env}*/}
      {/*    runs={runs}*/}
      {/*    setTimeline={setTimeline}*/}
      {/*    onClick={onRunHistoryClick}*/}
      {/*  />*/}
      {/*  <PipelineStages*/}
      {/*    api={api}*/}
      {/*    env={env}*/}
      {/*    className={'w-[25%]'}*/}
      {/*    timeline={timeline}*/}
      {/*    onClick={setJobs}*/}
      {/*    buildId={buildId}*/}
      {/*    loading={runDetailsLoading}*/}
      {/*  />*/}
      {/*  <div className={'w-[50%]'}>*/}
      {/*    {jobs.map((job, i) => (*/}
      {/*      <PipelineJobs*/}
      {/*        env={env}*/}
      {/*        api={api} buildId={buildId} job={job} />*/}
      {/*    ))}*/}
      {/*  </div>*/}
      {/*</div>*/}

      <RunNewBuild
        api={api}
        setTimeline={setTimeline}
        // setLogs={setLogs}
        // open={true}
        onClose={onDrawerClose}
      />
      {/*<RunNew*/}
      {/*  api={api}*/}
      {/*  setTimeline={setTimeline}*/}
      {/*  logsRef={logsRef}*/}
      {/*  setLogs={setLogs}*/}
      {/*  open={open}*/}
      {/*  onClose={onDrawerClose}*/}
      {/*/>*/}
    </div>
  )
}
